import { Component, OnInit, Input } from '@angular/core';
import { ContactpersonalOverviewModel, SubTitleWrapper } from 'src/app/classes';
import * as moment from 'moment';

@Component({
  selector: 'app-contact-preview',
  templateUrl: './contact-preview.component.html',
  styleUrls: ['./contact-preview.component.css']
})
export class ContactPreviewComponent implements OnInit {

  _contact: ContactpersonalOverviewModel;
  @Input() set contact(contact: ContactpersonalOverviewModel){
    this._contact = contact;
    this.subTitles = [];
    if(contact){
      this.contactPreview = "";
      if(contact.contactperspublicid) this.contactPreview += contact.contactperspublicid + " ";
      if(contact.contactpersfname) this.contactPreview += contact.contactpersfname + " ";
      if(contact.contactperslname) this.contactPreview += contact.contactperslname + " ";
      if(contact.accessed) this.subTitles.push({ type: "Verwendet", value: moment(contact.accessed).format("DD.MM.YYYY HH:mm:ss") });
      if(contact.contactpersondepartment) this.subTitles.push({ value: contact.contactpersondepartment, type: "Abteilung" } as SubTitleWrapper);
      if(contact.phone) this.subTitles.push({ value: contact.phone, type: "Telefon" } as SubTitleWrapper);
      if(contact.email) this.subTitles.push({ value: contact.email, type: "E-Mail" } as SubTitleWrapper);
      if(contact.fax) this.subTitles.push({ value: contact.fax, type: "Fax" } as SubTitleWrapper);
    }
  }
  get contact(): ContactpersonalOverviewModel {
    return this._contact;
  }

  contactPreview: string = "";
  subTitles: SubTitleWrapper[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
